const initialState = {
  data: [],
  totalCounts: 0,
  bucketCounts: { all: 0, athletes: 0, coaches: 0, pending: 0, uncompleted: 0, completed: 0 },
  user: {},
  usersByRole: [],
  usersByRoleTotalCounts: 0,
  logs: [],
  logTotalCounts: 0,
  allUsers: [],
  analytics: {},
  paymentHistory: {},
  allUserPaymentHistory: [],
  dependencies: [],
  // Why the signed-in user's record could not be loaded (network or server
  // trouble), so route guards can offer a way out instead of spinning.
  loadError: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ALL_USERS':
      return {
        ...state,
        data: action.payload,
        totalCounts: action.totalCounts,
        bucketCounts: action.bucketCounts || state.bucketCounts,
      };
    
    case 'FETCH_USERS_BY_ROLE':
      return { ...state, usersByRole: action.payload, usersByRoleTotalCounts: action.totalCounts };
    
    case 'CLEAR_USERS_BY_ROLE':
      return { ...state, usersByRole: [], usersByRoleTotalCounts: 0 };
    
    case 'UPDATE_USER':
      return { ...state, data: state.data.map(u => u.email === action.payload.email ? action.payload : u) };
    
    case 'CLEAR_ALL_USERS':
      return { ...state, data: [], totalCounts: 0 };
    
    case 'FETCH_USER_BY_EMAIL':
      return { ...state, user: action.payload, loadError: null };

    case 'FETCH_USER_FAILED':
      return { ...state, loadError: action.payload || 'We could not load your account.' };
    
    case 'USER_LOGOUT':
      return initialState;

    case 'FETCH_LOGS':
      return { ...state, logs: action.payload, logTotalCounts: action.totalCounts };

    case 'FETCH_WHOLE_USERS':
      return { ...state, allUsers: action.payload };

    case 'SET_ANALYTICS':
      return { ...state, analytics: action.payload };
    
    case 'FETCH_PAYMENT_HISTORY':
      return { ...state, paymentHistory: action.payload };
    
    case 'FETCH_ALL_USER_PAYMENT_HISTORY':
      return { ...state, allUserPaymentHistory: action.payload };

    case 'FETCH_DEPENDENCIES':
      return { ...state, dependencies: action.payload };
    
    default:
      return state;
  }
};

export default userReducer;
